import React from 'react'
import { FC, useCallback, useEffect, useState } from 'react'

import { ViewportSizes } from '@syconium/little-miss-figgy'

import { SlideItemProps } from '../constants'

import { SvgWrapper } from './Iphone.style'

interface IphoneProps {
  slideItems?: SlideItemProps[]
  background?: string
  index?: number
  viewport?: ViewportSizes
}

const Iphone: FC<IphoneProps> = ({ slideItems, background, index = 0, viewport }) => {
  const [pastIndex, setPastIndex] = useState(0)

  const setIndex = useCallback(() => {
    setPastIndex(pastIndex || index)
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index])

  useEffect(() => {
    !background && setIndex()
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index])

  const customViewport = viewport !== undefined ? `_${viewport}` : ''
  const extraId = `${index}${customViewport}`

  const imageMask = (key?: number) => {
    const customKey = key !== undefined ? `_${key}` : ''
    const customId = `${index}${customKey}${customViewport}`

    return (
      <React.Fragment key={key}>
        <mask
          id={`image_pattern_rect_${customId}`}
          maskUnits='userSpaceOnUse'
          x='144'
          y='23'
          width='321'
          height='692'
        >
          <path
            d='M189.785 23.7849C184.151 23.9565 178.846 24.5043 174.871 25.3246C163.232 27.7265 154.203 34.5948 149.49 44.6316C147.32 49.2517 146.181 53.7436 145.347 60.9629C145.032 63.6918 144.998 87.9623 144.93 365.779C144.876 580.67 144.92 668.892 145.082 672.014C145.592 681.87 147.13 688.784 150.041 694.308C155.833 705.3 165.781 711.586 180.155 713.338C186.009 714.051 186.229 714.053 299.177 714.133C412.619 714.214 421.303 714.162 427.726 713.457C438.982 712.206 446.259 709.063 452.657 702.689C458.953 696.415 462.127 689.121 463.41 677.971C463.59 676.408 463.831 672.688 463.942 669.706C464.22 662.323 464.222 75.5528 463.944 68.173C463.726 62.4137 463.37 58.6205 462.7 54.9249C459.83 39.0825 449.335 28.381 433.588 25.2357C426.669 23.8535 420.275 23.6024 394.123 23.6863L374.025 23.7508L373.152 24.2168C372.672 24.4731 372.082 24.9622 371.839 25.3033C370.93 26.5778 370.761 27.3653 370.549 31.2522C370.327 35.3482 369.992 37.3855 369.184 39.5366C367.262 44.6519 362.472 48.9763 357.129 50.4213C356.287 50.6483 354.625 50.9318 353.433 51.0511C350.302 51.3642 258.283 51.3491 255.376 51.0352C248.947 50.3403 244.091 47.3272 240.988 42.1073C239.298 39.2648 238.589 36.2528 238.363 30.9701C238.176 26.5705 237.662 25.2951 235.636 24.2024L234.798 23.7508L213.234 23.7391C201.374 23.7328 190.822 23.7533 189.785 23.7849Z'
            fill='white'
          />
        </mask>
        <g mask={`url(#image_pattern_rect_${customId})`}>
          <rect
            x='145.301'
            id={`image_wrapper_${key !== undefined ? key : 'static'}`}
            width='319.174'
            height='691.407'
            fill={`url(#image_pattern_${customId})`}
          />
        </g>
      </React.Fragment>
    )
  }

  const imagePattern = (image: string, key?: number) => {
    const customKey = key !== undefined ? `_${key}` : ''
    const customId = `${index}${customKey}${customViewport}`
    return (
      <React.Fragment key={key}>
        <pattern
          id={`image_pattern_${customId}`}
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref={`#image_${customId}`}
            transform='translate(-0.000591041) scale(0.000853523 0.000394011)'
          />
        </pattern>
        <image id={`image_${customId}`} width='1173' height='2538' xlinkHref={image} />
      </React.Fragment>
    )
  }

  return (
    <SvgWrapper index={index || 0} pastIndex={pastIndex}>
      <svg width='100%' viewBox='0 0 483 821' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g opacity='0.83'>
          <rect
            x='-0.000732422'
            width='478.394'
            height='832'
            fill={`url(#shadow_pattern_${extraId})`}
          />
        </g>
        <rect
          x='124.989'
          y='7.1145'
          width='358.01'
          height='724.024'
          fill={`url(#iphone_pattern_${extraId})`}
        />
        {slideItems?.map((_slide, key) => imageMask(key))}
        {background && imageMask()}
        <defs>
          <pattern
            id={`shadow_pattern_${extraId}`}
            patternContentUnits='objectBoundingBox'
            width='1'
            height='1'
          >
            <use xlinkHref={`#shadow_${extraId}`} transform='scale(0.000437637 0.000251509)' />
          </pattern>
          <pattern
            id={`iphone_pattern_${extraId}`}
            patternContentUnits='objectBoundingBox'
            width='1'
            height='1'
          >
            <use xlinkHref={`#iphone_${extraId}`} transform='scale(0.000584795 0.000289017)' />
          </pattern>
          {slideItems?.map((slide, key) => imagePattern(slide.image, key))}
          {background && imagePattern(background)}
          <image
            id={`shadow_${extraId}`}
            width='2285'
            height='3976'
            xlinkHref='https://cdn.shopify.com/s/files/1/0139/8942/files/Shadow_1.png?v=1662494528'
          />
          <image
            id={`iphone_${extraId}`}
            width='1710'
            height='3460'
            xlinkHref='https://cdn.shopify.com/s/files/1/0139/8942/files/Gold.png?v=1661236756'
          />
        </defs>
      </svg>
    </SvgWrapper>
  )
}

export default Iphone
